import styled from 'styled-components';
import React from 'react';

const FileViewStyled = styled.div`
  width: 100%;
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export function FileView({ children }) {
  return <FileViewStyled>{children}</FileViewStyled>;
}
